/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback
} from "react";
import { useSelector } from "react-redux";
import { generatePath, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { format } from "date-fns";
import { Container, Image, Carousel, ImageWithLoader } from "app/components";
import { useConfig } from "app/hooks";
import { Title } from "../AllTechnologies/styles";
import { TechnologyDetailsWrapper } from "./styles";

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  movies: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  location: PropTypes.string.isRequired,
  findMovie: PropTypes.func.isRequired,
  getTechnologies: PropTypes.func.isRequired
};

const TechnologyDetails = ({
  match,
  movies,
  location,
  findMovie,
  getTechnologies
}) => {
  const [t, i18n] = useTranslation();
  const { language } = i18n;
  const { id } = match.params;
  const { routes } = useConfig();
  const sliderRef = useRef(null);
  const technologies = useSelector(state => state.technologies.technologies);
  const technologyInfo = technologies?.find(item => item?.id === +id);

  const [technologyDetails, setTechnologyDetails] = useState({
    headline1: '',
    headline2: '',
    picture: '',
    longDescription: ``
  });

  useEffect(() => {
    getTechnologies();
  }, []);

  useEffect(() => {
    if (technologyInfo?.id) {
      const body = {
        technology: [technologyInfo?.headline1]
      };

      findMovie(body, { location });
    }
  }, [technologyInfo]);

  useEffect(() => {
    if (technologyInfo?.id) {
      const {
        headline1,
        headline1EN,
        headline2,
        headline2EN,
        picture,
        longDescription,
        longDescriptionEN
      } = technologyInfo;

      setTechnologyDetails({
        headline1: language === 'en' ? headline1EN : headline1,
        headline2: language === 'en' ? headline2EN : headline2,
        picture,
        longDescription: language === 'en' ? longDescriptionEN : longDescription
      });
    }
  }, [technologyInfo]);

  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    centerMode: true,
    centerMargin: "20px",
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 3
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 2
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  const movieList = useCallback(() => {
    return movies?.map(item => (
      <NavLink
        key={item?.id}
        to={{
          pathname: generatePath(routes.movieDetails.pattern, {
            // id: item?.shortURL ? item?.shortURL : item?.titleCalculated?.replaceAll(' ', '-')
            id: item?.titleCalculated.replaceAll(' ', '-')
          }),
          search: `?date=${format(new Date(), 'yyyy-MM-dd')}&location=${location}`,
          state: { movieId: item?.id }
        }}
        className="technology-details__carousel-item-wrapper"
      >
        <div className="technology-details__carousel-item">
          <Image
            className="technology-details__carousel-item-image"
            src={item?.posterImage}
            alt={item?.name}
          />
          <h3>
            {t('common.filmstart')}: {format(new Date(item?.openingDate), 'dd.MM.yyyy')}
          </h3>
          <h2>{item?.titleCalculated}</h2>
          <h3 className="technology-details__carousel-item-description">{item?.shortSynopsis}</h3>
        </div>
      </NavLink>
    ));
  }, [movies]);

  return (
    <Container>
      <Title>{t('common.technology_details')}</Title>
      <TechnologyDetailsWrapper>
        <div className="technology-details__header">
          <h1>{technologyDetails?.headline1}</h1>
          <h2>{technologyDetails?.headline2}</h2>
        </div>
        <div className="technology-details__image-wrapper">
          <ImageWithLoader
            type="cinema"
            imgSrc={technologyDetails?.picture}
            imgTitle={technologyDetails?.headline1}
          />
        </div>
        <div className="technology-details__description">
          {parse(technologyDetails?.longDescription)}
        </div>
        <div
          className="technology-details__carousel-wrapper"
          style={{ justifyContent: "start" }}
        >
          {movies?.length >= 3 ? (
            <Carousel
              {...sliderProps}
              refEl={sliderRef}
              autoPlay={movies?.length >= 3}
              autoPlaySpeed={4000}
              infinite={movies?.length >= 3}
              className="cinema-rent__carousel giftCardSliderData technology-details__carousel"
            >
              {movieList()}
            </Carousel>
          ) : (
            movies?.length > 0 && (
              <div className="technology-details__movies-wrapper">{movieList()}</div>
            )
          )}
        </div>
      </TechnologyDetailsWrapper>
    </Container>
  );
};

TechnologyDetails.propTypes = propTypes;

export default TechnologyDetails;
